import { BitmapText } from 'pixi.js';

export function isFontAvailable(fontName: string): boolean {
  return Object.hasOwnProperty.call((BitmapText as any).fonts, fontName);
}
